<template>
  <v-card>
    <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>
    <v-tabs
      background-color="#006699"
      color="white"
      right
    >
      <v-tab>Identificação</v-tab>
      <v-tab>Contactos</v-tab>
       <v-tab-item>
        <template>
            <v-card
              class="mx-auto"
               outlined
            >
            <v-alert
          v-model="alert"
          dismissible
          close-icon="remove"
          color="green"
          border="left"
          elevation="2"
          colored-border
          icon="done"
        >
        <strong>Configurações</strong> actualizadas com sucesso!
      </v-alert>
             <v-card-title>Identificação da Empresa</v-card-title>
             <v-card-text>
               <v-row>
                 <v-col md="12"><span style="font-weight:bold;">Nº de contribuinte:</span> </v-col>
                 <v-col md="6">
                   <v-text-field
                   v-model="editedItemIdentificacao.nif"
                    label="Solo"
                    :rules="ruleRequired"
                    hint="Número de identificação fiscal da empresa"
                    persistent-hint
                    solo
                  ></v-text-field>
                  </v-col>
               </v-row>
               <v-row>
                 <v-col md="12"><span style="font-weight:bold;">Empresa:</span> </v-col>
                 <v-col md="6">
                   <v-text-field
                   v-model="editedItemIdentificacao.empresa"
                    label="Solo"
                    :rules="ruleRequired"
                     hint="Nome da empresa"
                     persistent-hint
                    solo
                  ></v-text-field>
                  </v-col>
               </v-row>
               <v-row>
                 <v-col md="12"><span style="font-weight:bold;">Email:</span> </v-col>
                 <v-col md="6">
                   <v-text-field
                   v-model="editedItemIdentificacao.email"
                    label="Solo"
                    :rules="usernameRule"
                    hint="Email da Empresa"
                    persistent-hint
                    solo
                  ></v-text-field>
                  </v-col>
               </v-row>
             </v-card-text>

            </v-card>
          </template>
      </v-tab-item>
      <v-tab-item>
        <template>
            <v-card
              class="mx-auto"
               outlined
            >
            <v-alert
          v-model="alert"
          dismissible
          close-icon="remove"
          color="green"
          border="left"
          elevation="2"
          colored-border
          icon="done"
        >
        <strong>Configurações</strong> actualizadas com sucesso!
      </v-alert>
             <v-card-title>Contactos</v-card-title>
             <v-card-text>
               <v-row>
                 <v-col md="12"><span style="font-weight:bold;">Website:</span> </v-col>
                 <v-col md="6">
                   <v-text-field
                   v-model="editedItemIdentificacao.site"
                    label="Solo"
                    :rules="ruleRequired"
                    hint="Website  da empresa"
                    persistent-hint
                    solo
                  ></v-text-field>
                  </v-col>
               </v-row>
               <v-row>
                 <v-col md="12"><span style="font-weight:bold;">Cidade:</span> </v-col>
                 <v-col md="6">
                   <v-text-field
                   v-model="editedItemIdentificacao.provincia"
                    label="Solo"
                    :rules="ruleRequired"
                     hint="Cidade em que a sede está localizada"
                     persistent-hint
                    solo
                  ></v-text-field>
                  </v-col>
               </v-row>
               <v-row>
                 <v-col md="12"><span style="font-weight:bold;">Localidade:</span> </v-col>
                 <v-col md="6">
                   <v-text-field
                   v-model="editedItemIdentificacao.localidade"
                    label="Solo"
                    :rules="ruleRequired"
                    hint="Municipio, bairro e rua"
                    persistent-hint
                    solo
                  ></v-text-field>
                  </v-col>
               </v-row>
             </v-card-text>

              <v-card-actions style="float:right;margin-top:-60px;">
                <v-btn  color="#006699" style="color:white;"  @click="Actualizar()">Actualizar dados</v-btn>
              </v-card-actions>
            </v-card>
          </template>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>
<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    alert: false,
    editedItemIdentificacao: {
      nif: '',
      empresa: '',
      email: '',
      provincia: '',
      localidade: '',
      site: ''
    },
    overlay: false,
    formValid: true,
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    usernameRule: [
      // this.value.replace(/[^\d]/, ''),

      v => !!v || 'campo obrigatório.',
      v => {
        const pattern = /([^A-Za-z0-9])$/
        return !pattern.test(v) || 'Inválido.'
      }
    ]
  }),
  created () {
    this.editedItemIdentificacao.empresa = ls.get('empresa')
    this.editedItemIdentificacao.email = ls.get('emailEmpresa')
    this.editedItemIdentificacao.nif = ls.get('nif')
    this.editedItemIdentificacao.provincia = ls.get('provincia')
    this.editedItemIdentificacao.localidade = ls.get('localidade')
    this.editedItemIdentificacao.site = ls.get('site')
  },
  methods: {
    async  Actualizar () {
      this.overlay = true
      const params =
      {
        empresa: this.editedItemIdentificacao.empresa,
        email: this.editedItemIdentificacao.email,
        nif: this.editedItemIdentificacao.nif,
        provincia: this.editedItemIdentificacao.provincia,
        localidade: this.editedItemIdentificacao.localidade,
        site: this.editedItemIdentificacao.site

      }

      // consumindo a API
      try {
        let msg = await axios
          .post('/ActualizarDadosEmpresa', params)
          .then(res => res.data)
        if (msg.affectedRows >= 1) {
          this.overlay = false
          this.alert = true
          setTimeout(() => {
            this.alert = false
            this.setLs()
          }, 2000)
        }

        this.textMessage = msg
      } catch (error) {

      }
    },
    setLs () {
      ls.set('emailEmpresa', this.editedItemIdentificacao.email)
      ls.set('nif', this.editedItemIdentificacao.nif)
      ls.set('site', this.editedItemIdentificacao.site)
      ls.set('provincia', this.editedItemIdentificacao.provincia)
      ls.set('localidade', this.editedItemIdentificacao.localidade)
      ls.set('empresa', this.editedItemIdentificacao.empresa)
    }
  }
}
</script>
